module.exports = __webpack_public_path__ + "img/dashboard.35592bb0.png";